import { Box } from '@chakra-ui/react';
import React from 'react';

const InputWrapper = ({ children }) => {
  return (
    <Box m={0} pt={[2]} pb={2}>
      {children}
    </Box>
  );
};

export default InputWrapper;
